var _path, _path2, _rect, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVerifyWithClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 68V21C56 16.5817 52.4183 13 48 13H14C9.58172 13 6 16.5817 6 21V68",
    stroke: "url(#paint0_linear_6518_9909)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9062 45.3193H33.0869C39.3829 45.3194 44.5 50.4254 44.5 56.6992C44.5 57.139 44.1413 57.5 43.6943 57.5H19.3057C18.8587 57.5 18.5 57.139 18.5 56.6992C18.5 50.4315 23.6186 45.3193 29.9062 45.3193ZM31.4961 28.5C34.7132 28.5 37.3135 31.1017 37.3135 34.2959C37.3133 37.4982 34.7121 40.0986 31.4961 40.0986C28.2864 40.0985 25.6865 37.5041 25.6865 34.3027C25.6866 31.0995 28.2884 28.5001 31.4961 28.5Z",
    stroke: "url(#paint1_linear_6518_9909)",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.1035,
    y: 11.1221,
    width: 14.3336,
    height: 14.3336,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5544 7.59442L56.7883 2.17326L56.606 2.10033C56.0795 1.96656 55.528 1.96656 55.0015 2.10033L54.8192 2.17326L43.0531 7.59442C42.4973 7.8503 42.0317 8.26799 41.7173 8.79283C41.4028 9.31766 41.2541 9.9252 41.2906 10.5359L41.7038 17.44C41.9384 21.411 43.297 25.2335 45.6213 28.4617C47.9456 31.6899 51.1398 34.1907 54.8313 35.6726C55.1407 35.8119 55.4766 35.8824 55.8159 35.8793C56.1384 35.8842 56.458 35.8178 56.7518 35.6848C60.4479 34.2065 63.6472 31.7073 65.976 28.4788C68.3048 25.2503 69.667 21.4259 69.9036 17.4522L70.3169 10.5481C70.3559 9.93535 70.2084 9.32516 69.8938 8.7979C69.5791 8.27064 69.1122 7.85106 68.5544 7.59442ZM62.1851 16.103L55.6943 23.396C55.5887 23.5169 55.4603 23.6156 55.3163 23.6865C55.1724 23.7575 55.0158 23.7992 54.8556 23.8093H54.7949C54.4894 23.8115 54.1943 23.6987 53.9683 23.4933L49.5074 19.3848C49.2705 19.1656 49.1303 18.8613 49.1178 18.5387C49.1052 18.2162 49.2213 17.9018 49.4405 17.6649C49.6598 17.428 49.9641 17.2878 50.2867 17.2753C50.6092 17.2627 50.9235 17.3788 51.1605 17.598L54.7098 20.8678L60.3619 14.4985C60.5788 14.2726 60.8746 14.1392 61.1875 14.1261C61.5005 14.1129 61.8064 14.2211 62.0415 14.428C62.2766 14.6349 62.4228 14.9246 62.4496 15.2367C62.4763 15.5487 62.3816 15.8591 62.1851 16.103Z",
    fill: "url(#paint2_linear_6518_9909)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6518_9909",
    x1: 68.3853,
    y1: 67.9969,
    x2: 8.29357,
    y2: 67.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6518_9909",
    x1: 53.1835,
    y1: 58.9982,
    x2: 18.3303,
    y2: 58.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6518_9909",
    x1: 77.5159,
    y1: 35.8776,
    x2: 42.6172,
    y2: 35.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVerifyWithClear);
export default __webpack_public_path__ + "static/media/ic-verify-with-clear.1cb803dc20ddb53c5499faa2e5ddff44.svg";
export { ForwardRef as ReactComponent };